<template>
	<v-card class="event-preview-card elevation-0 d-flex flex-column pb-7">
		<div class="event-preview-card__container">
			<div class="event-preview-card__outer">
				<div class="d-flex event-preview-card__list pl-0 pr-0">
					<div class="d-flex flex-column">
						<router-link
							:to="{ name: 'event-by-id', params: { id: this.event.event_id } }"
							class="text-decoration-none text--black"
						>
							<div class="event-preview-card__preview-image">
								<ProfileBadge
									v-if="event.pin_to_top"
									isPin
									:pin="{ icon: pinnedIcon, text: 'Pinned' }"
								/>

								<img
									v-if="!!event.event_image"
									:src="event.event_image"
									alt="event-image-previw"
									class="event-preview-card__preview-image"
								/>
							</div>

							<div
								class="d-flex flex-column justify-space-around pa-4 ms-4"
								v-bind:style="{
									paddingTop: event.event_image ? '0' : '32px !important',
								}"
							>
								<div class="event-preview-card__title mb-4">
									{{ event.event_title }}
								</div>

								<div class="event-preview-card__content-inner mb-4">
									{{ event.dateTimePeriodToString }}
								</div>

								<div class="event-preview-card__location mb-4" v-if="event.address">
									<Icon
										v-if="
											event.address.address_city ||
											event.address.address_state ||
											event.address.address_country
										"
										type="pin"
										color="#0055A3"
										:size="12"
										:pr="4"
									/>
									{{ getAddressLine(event.address) }}
								</div>

								<div class="d-flex flex-column mt-5 mb-3 black--text">
									<div class="d-flex">
										<div style="margin-top: 3px">
											<Icon
												color="#697583"
												class="mr-4"
												type="grid"
												:size="15"
											/>
										</div>

										<div
											class="mb-3 font-weight-bold ml-1"
											style="color: #697583; margin-left: -8px !important"
										>
											{{ event.category.category_name || 'Cybersecurity' }}
										</div>
									</div>

									<v-card-text
										v-html="
											cutTextToSetCharacters(
												event.event_description || '',
												400
											)
										"
									></v-card-text>
								</div>

								<v-card-subtitle
									class="post-preview-card__meta-bottom d-flex px-4 pa-0"
									style="margin-left: -15px"
								>
									<div v-if="event.tags.length">
										<v-chip
											v-for="(tag, index) in event.tags"
											:color="tag.tag_bg_color"
											:text-color="tag.tag_txt_color"
											class="post-preview-card__tag mr-2 mb-2 px-3 py-3"
											:key="index"
										>
											#{{ tag.tag }}
										</v-chip>
									</div>
								</v-card-subtitle>
							</div>
						</router-link>

						<v-divider />

						<div class="d-flex justify-space-between my-4 px-5 font-weight-bold">
							<div
								v-if="!isSchedule"
								class="event-preview-card__link"
								@click="onSchedule"
								style="cursor: pointer"
							>
								Add to My Agenda
							</div>
							<div
								v-else
								class="event-preview-card__link"
								@click="onSchedule"
								style="cursor: pointer; color: #a0a0a0"
							>
								Remove from My Agenda
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import bookmarkedIcon from '@/assets/images/postIcon/icon-bookmarked.svg'
import Dwh from '@/mixins/Dwh'
import ProfileBadge from '@/components/ProfileBadge.vue'
import { mapActions } from 'vuex'

Vue.use(VueScrollTo)

export default {
	name: 'EventPreview',
	components: {
		ProfileBadge,
	},
	mixins: [Dwh],
	props: {
		event: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			isSchedule: 0,
			pinnedIcon,
			bookmarkedIcon,
		}
	},

	methods: {
		...mapActions('event', ['addEventToSchedule', 'removeEventFromSchedule']),

		cutTextToSetCharacters(text, count) {
			if (!text || typeof text !== 'string') return ''
			if (text.length <= count) {
				return text
			} else {
				const parser = new DOMParser()
				const doc = parser.parseFromString(text, 'text/html')
				const truncatedHTML = doc.body.innerHTML.slice(0, count)
				return truncatedHTML + '...'
			}
		},
		getAddressLine(address) {
			return [address.address_city, address.address_state, address.address_country]
				.filter(function (v) {
					return v !== null
				})
				.join(',')
		},

		onSchedule() {
			if (this.isSchedule) {
				this.removeEventFromSchedule(this.event.event_id)
			} else if (!this.isSchedule) {
				this.addEventToSchedule({ event_id: this.event.event_id })
				this.sendTrigger({
					category: 'Content',
					action: 'click_add_to_schedule_event_list',
					module: 'Events',
					data: this.event.event_id,
					title: this.event.event_title,
					content_chapter_id: this.event.chapter_id ? [this.event.chapter_id] : null,
				})
			}

			this.isSchedule = !this.isSchedule
		},
	},
	created() {
		if (this.event) {
			this.isSchedule = this.event.schedule
		}
	},
}
</script>

<style lang="scss">
.event-preview-card {
	background: #f1f1f1 !important;
	font-family: Montserrat, sans-serif;
	color: rgb(74, 74, 74);

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
		background: white !important;
	}

	&__content-inner {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 18px;

		img {
			width: 100%;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}

	&__preview-image {
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	&__location {
		display: flex;
		color: #0055a3;
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		letter-spacing: 0px;
		line-height: 17px;
	}

	&__meta {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: rgb(66, 160, 216);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: rgb(155, 155, 155);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			line-height: 16px;

			span {
				min-width: 85px;
			}
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__outer {
	}

	&__list {
		flex-direction: column;
	}

	&__link {
		color: var(--button-main-background-color);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;

		a {
			color: var(--button-main-background-color) !important;
		}
	}

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		letter-spacing: 0px;
		line-height: 22px;
		font-style: normal;

		a {
			color: #202232 !important;
			text-decoration: none;
		}
	}

	&__block-view {
		flex-direction: column;
		height: 73%;

		.post-preview-card__thumbnail-outer img {
			max-width: 100%;
		}
	}

	&__content {
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 21px;
	}

	&__thumbnail {
		height: auto;
		width: 100%;
		max-height: 143px;
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		&:hover {
			color: #fff !important;
			background-color: rgb(66, 160, 216) !important;
		}
	}

	&__like-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa;

		&-active {
			color: #db7842 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__share-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa !important;
		cursor: pointer;

		.v-icon {
			transform: rotateY(180deg);
		}

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__book-button {
		color: var(--accent-color);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-decoration: underline;

		&-active {
			color: #0a00a5 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__comment {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.43px;
		width: 100%;

		&::placeholder {
			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}

		&:focus {
			outline: none;
		}

		&-send {
			width: 38px;
			height: 22px;
			color: rgb(160, 160, 160);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__comments-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		display: flex;
		align-items: flex-end;
		color: #aaaaaa;
		cursor: pointer;

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__my-menu {
		margin-top: 20px;
		min-width: 175px !important;
		contain: initial !important;
		overflow: visible !important;

		&:before {
			content: '';
			position: absolute;
			left: 14px;
			top: 0;
			z-index: -1;
			border-radius: 3px;
			transform: translate(0, -50%) rotate(45deg);
			width: 20px;
			height: 20px;
			background: #fff;
			box-shadow: 0 0 11px rgb(0 0 0 / 14%);
		}
	}

	&__menu-dots {
		margin-left: 10px !important;
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			max-height: 250px;
			height: 100%;
			max-width: 100%;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

.dropdown-profile {
	padding: 15px;

	&__item {
		min-height: 30px !important;
		padding: 0;
	}

	&__title {
		color: #aaaaaa;
		font-size: 12px !important;
		line-height: 1.4 !important;
		font-family: 'Montserrat', sans-serif !important;
		font-weight: 600 !important;
	}

	&__title:hover {
		text-decoration: underline;
		color: black;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
	}
}
</style>
